import { Outlet, createFileRoute } from '@tanstack/react-router';
import { Bookmark, Compass, History, Home, Settings, Users, Newspaper } from 'lucide-react';
import { useMemo } from 'react';

import type { SidebarNavGroup } from '@/components/layout/Sidebar';

import { AppShell } from '@/components/layout/AppShell';
import { useRequireAuth } from '@/lib/auth/useRequireAuth';
import { crossSurfaceLinks } from '@/lib/nav/roleNav';

export const Route = createFileRoute('/subscriber')({
  component: SubscriberLayout,
});

const primaryGroups: SidebarNavGroup[] = [
  {
    items: [
      { to: '/subscriber', label: 'Home', icon: Home },
      { to: '/subscriber/discover', label: 'Discover', icon: Compass },
      { to: '/subscriber/feed', label: 'Following', icon: Newspaper },
      { to: '/subscriber/saved', label: 'Saved', icon: Bookmark },
      { to: '/subscriber/history', label: 'History', icon: History },
      { to: '/subscriber/contributors', label: 'Contributors', icon: Users },
      { to: '/subscriber/settings', label: 'Settings', icon: Settings },
    ],
  },
];

const bottomNavItems = [
  { to: '/subscriber', label: 'Home', icon: Home },
  { to: '/subscriber/discover', label: 'Discover', icon: Compass },
  { to: '/subscriber/feed', label: 'Following', icon: Newspaper },
  { to: '/subscriber/saved', label: 'Saved', icon: Bookmark },
];

function SubscriberLayout() {
  const { loading, profile } = useRequireAuth();
  // Role-aware chrome (Spec 27): append a "Manage" group with the cross-surface
  // destinations this person can reach. A free reader gets none — its baseline
  // is unchanged.
  const groups = useMemo(() => {
    const base = [...primaryGroups];
    const cross = crossSurfaceLinks(profile, 'subscriber');
    if (cross.length) base.push({ label: 'Manage', items: cross });
    return base;
  }, [profile]);
  if (loading) return null;
  return (
    <AppShell
      pageTitle="Your home"
      sidebarGroups={groups}
      bottomNavItems={bottomNavItems}
      homeHref="/subscriber"
    >
      <Outlet />
    </AppShell>
  );
}
